module.exports = __webpack_public_path__ + "static/media/112591.55c13219.jpg";